import { api } from "./plugins/axios";


export function enToFaNum(value: string): string {
  value = value.toString()
  const englishNumbers = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', ','],
    persianNumbers = ['۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹', '۰', '،']

  for (let i = 0; i < 11; i++) {
    if (englishNumbers[i] && persianNumbers[i]) {
      if (englishNumbers[i] && persianNumbers[i]) {
        value = value.replace(new RegExp(englishNumbers[i] as string, 'g'), persianNumbers[i] as string);
      }
    }
  }
  return value
}

export function faToEnNum(value: string): string {
  value = value.toString()
  const englishNumbers = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', ','],
    persianNumbers = ['۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹', '۰', '،']

  for (let i = 0; i < 11; i++) {
value = value.replace(new RegExp(persianNumbers[i]!, 'g'), englishNumbers[i]!)
  }
  return value
}

export function NumFormat(value: string | number): string {
  value = String(value)
  if (value.length <= 3) {
    return value
  }

  let out = ''
  let cursor = 0
  for (let i = value.length - 1; i >= 0; i--) {
    // علامت منفی جداکننده نمی‌گیرد (گرنه "-,100" تولید می‌شود)
    const separator = cursor > 0 && cursor % 3 === 0 && value[i] !== '-' ? ',' : ''
    out = value[i] + separator + out
    cursor++
  }

  return out
}

export function enToFaNumFormat(value: string): string {
  value = enToFaNum(NumFormat(value))
  return value
}

export const Template = (template: string, data: Record<string, string | number>): string => {
  if (typeof template === 'undefined' || template === '') {
    return ''
  }
  try {
    Object.keys(data).forEach((k) => {
      if (data[k] === null || typeof template === 'undefined' || typeof data[k] === 'undefined') {
        return
      }
      template = template.replace(`\${` + k + `}`, data[k] as string)
      template = template.replace(`{{` + k + `}}`, data[k] as string)
    })
  } catch (e) {
    console.log('Template Error', e)
  }
  return template
}

export function shuffleArray<T>(array: T[]): T[] {
  let currentIndex = array.length,
    randomIndex;

  while (currentIndex != 0) {
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    [array[currentIndex]!, array[randomIndex]!] = [array[randomIndex]!, array[currentIndex]!];
  }

  return array;
}

export function RandomString(length: number): string {
  let result = ''
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-'
  const charactersLength = characters.length
  let counter = 0
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
    counter += 1
  }
  return result
}

export function useEncodeURI(value: string)  {
  return value.split('/').map(encodeURIComponent).join('/')
}

export function useLetterSeparator(value:string) {
  return value.replace(/_/g, ' ')
}

export function formatNumberWithCommas(value: string | number): string {
  if (value === null || value === undefined) return ''

  const num = typeof value === 'number' ? value : Number(value)

  if (isNaN(num)) return ''

  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export function extractMessage(err: unknown): Message | null {
  if (api.isAxiosError(err)) {
    const status = err.response?.status
    const message = (err as any).response?.data?.message

    if (message && typeof message === 'object') return message as Message

    return { header: 'خطا', body: message ?? 'مشکل در سرور' }
  }
  // return { header: 'خطا', body: 'مشکل ناشناخته' }
  return null
}

export const formatDate = (dateStr: string) => {
  if (!dateStr) return ''

  return new Intl.DateTimeFormat('fa-IR', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  }).format(new Date(dateStr))
}

// format time for chat
export const formatTime = (dateStr: string) => {
  if (!dateStr) return ''

  const [datePart, timePart] = dateStr.split(' ')


  const [hours, minutes] = timePart?.split(':') || ['', '']


  return `${datePart} ${hours}:${minutes}`
}

export const hasIconsInUrl = (url: string): boolean => {
  return url.includes('icons') || url.includes('icon');
}
